import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const LocationsFilterLoadingSkeleton = memo(() => (
  <div className="my-2 flex w-full items-center justify-center">
    <Spinner className="size-5 text-grey-9" />
  </div>
));

LocationsFilterLoadingSkeleton.displayName = 'LocationsFilterLoadingSkeleton';
